module.exports = __webpack_public_path__ + "img/Weapon_138.b6ddcbba.png";